declare global {
  interface Window {
    grecaptcha?: {
      ready(cb: () => void): void
      execute(siteKey: string, options: {action: string}): Promise<string>
    }
  }
}

let scriptPromise: Promise<void> | null = null

function injectScript(siteKey: string): Promise<void> {
  if (scriptPromise) {
    return scriptPromise
  }

  scriptPromise = new Promise<void>((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>(`script[src^="https://www.google.com/recaptcha/api.js"]`)

    if (existing) {
      // Script tag already in DOM; assume it will initialize grecaptcha
      existing.addEventListener('load', () => resolve())
      existing.addEventListener('error', () => reject())
      return
    }

    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject()
    document.head.appendChild(script)
  })

  return scriptPromise
}

export async function getRecaptchaToken(siteKey: string, action: string): Promise<string | null> {
  try {
    await injectScript(siteKey)

    if (!window.grecaptcha) {
      console.warn('grecaptcha is not available after script load')
      return null
    }

    return new Promise<string | null>((resolve) => {
      window.grecaptcha!.ready(async () => {
        try {
          const token = await window.grecaptcha!.execute(siteKey, {action})
          resolve(token)
        } catch (e) {
          console.error('Error executing reCAPTCHA', e)
          resolve(null)
        }
      })
    })
  } catch (e) {
    console.error('Error loading reCAPTCHA script', e)
    return null
  }
}
